export default {"src":"/_next/static/media/bulldogjob-logo.c170dcb7.svg","height":133,"width":503,"blurWidth":0,"blurHeight":0};